import { useQuery } from '@tanstack/react-query'
import type { $Fetch, FetchOptions } from './fetchType'
import { useAuthedRequestFn } from './request-fn'

export { useAuthedRequestFn, useAuthedPlaidLink } from './request-fn'

export * from './firebase'

export function useClerkQuery(url: string, options?: FetchOptions, enabled?: boolean) {
  const queryKey: Array<string | object> = [url]
  if (options) {
    queryKey.push(options)
  }
  //console.log("yo yo!", queryKey)
  const authedOfetch = useAuthedRequestFn()
  return useQuery({
    queryKey,
    queryFn: () => authedOfetch(url, options),
    /* queryFn: async () => {
      console.log("um")
      const res = await authedOfetch(url, options);
      console.log({res})
      if (!res.ok) {
        throw new Error('Network response error')
      }
  
      return res//.json()
    }, */
    enabled: enabled === undefined ? true : enabled,
  })
}

export const TZAApiClient = {
  chat: (messages: string[], options?: { authedRequestFn?: $Fetch }) => {
    const authedRequestFn = options?.authedRequestFn || useAuthedRequestFn()
    return authedRequestFn<{
    userId: string;
    message: string;
    itsMe: boolean;
    time: number;
    msgId: any;
    conversationId: string;
}>('/chat-demo', {
      method: 'POST',
      body: { messages },
    })
  },
  internalAdmin: (options?: { authedRequestFn?: $Fetch }) => {
    const authedRequestFn = options?.authedRequestFn || useAuthedRequestFn()
    return authedRequestFn<{[x: string]: {
        title: string;
        prompt: {content: string; role: string;};
    }}>('/misc/internal-admin/prompts', {
      method: 'GET',
    })
  },
  useFinancialProfile: () => useClerkQuery('/financial-profile'),
  ssoLink: (options?: { authedRequestFn?: $Fetch }) => {
    const authedRequestFn = options?.authedRequestFn || useAuthedRequestFn()
    return authedRequestFn<{ token: string }>('/auth/sso-link', {
      method: 'GET',
    })
  },
}
